var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 20.8283 0.671719 21.5 1.5 21.5H28.5C29.3283 21.5 30 20.8283 30 20V5H0V20ZM21 10.25C21 9.83562 21.3356 9.5 21.75 9.5H26.25C26.6644 9.5 27 9.83562 27 10.25V11.75C27 12.1644 26.6644 12.5 26.25 12.5H21.75C21.3356 12.5 21 12.1644 21 11.75V10.25ZM21 15.875C21 15.6678 21.1678 15.5 21.375 15.5H26.625C26.8322 15.5 27 15.6678 27 15.875V16.625C27 16.8322 26.8322 17 26.625 17H21.375C21.1678 17 21 16.8322 21 16.625V15.875ZM3 11.375C3 11.1678 3.16781 11 3.375 11H17.625C17.8322 11 18 11.1678 18 11.375V12.125C18 12.3322 17.8322 12.5 17.625 12.5H3.375C3.16781 12.5 3 12.3322 3 12.125V11.375ZM3 15.875C3 15.6678 3.16781 15.5 3.375 15.5H11.625C11.8322 15.5 12 15.6678 12 15.875V16.625C12 16.8322 11.8322 17 11.625 17H3.375C3.16781 17 3 16.8322 3 16.625V15.875ZM29.25 0.5H0.75C0.335625 0.5 0 0.835625 0 1.25V3.5H30V1.25C30 0.835625 29.6644 0.5 29.25 0.5Z",
    fill: "#0083DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card-icon.5703c7a5aecf1b77cdf06710581ae179.svg";
export { ForwardRef as ReactComponent };